interface IPagesList {
    id: string,
    url: string
}


const pagesList: IPagesList[] = [
    {
        id: "download",
        url: `/download/:id?`
    },
    {
        id: "removeAccount",
        url: `/removeAccount/:id?`
    }
]

export default pagesList;
